/**
 *   Import
 *   - Libraies
 */
import * as React from 'react'
import glamorous from 'glamorous'
import { InjectedFormikProps } from 'formik'
import { Redirect } from 'react-router-dom'

/**
 *   Import
 */
import { Props } from '../../pages/Recover/Recover'
import { Values } from '../../../containers/pages/RecoverForm/RecoverForm'

/**
 *   Import
 *   - UI Components
 */
import { Alert } from '../../common/Alert/Alert'
import { Input } from '../../common/Input/Input'
import { SubmitButton } from '../../common/SubmitButton/SubmitButton'
import { FormTitle } from './components/FormTitle/FormTitle'
import { Form } from './components/Form/Form'
import { StyledForgotForm, StyledForgotMessage } from './RecoverForm.glamorous'

/**
 *   CSS Styles
 */
export const StyledInput = glamorous(Input)({
    padding: '0 80px 20px',
})

export const LastStyledInput = glamorous(StyledInput)({
    padding: '0 80px 40px',
})

export class RecoverForm extends React.Component<InjectedFormikProps<Props, Values>> {

    constructor(props: any) {
        super(props)
    }

    handleFocus(event: any) {
        event.target.previousSibling.classList += ' active'
    }

    render() {

        let props = this.props

        /**
         *  If server response is positive
         *  redirects to login page
         */
        if (props.recoverSuccess) {
            return(<Redirect to="/login" />)
        }

        return (
            <StyledForgotForm>

                <FormTitle>Recover password</FormTitle>

                {(!!Object.keys(props.errors).length && !!Object.keys(props.touched).length) && (
                    Object.keys(props.errors).filter(msg =>
                        Object.keys(props.touched).includes(msg)).map((error, idx) => {
                        const msg = props.errors[error]
                        return (
                            <Alert type="error">
                            <p key={`${error}${idx}`}>{`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`}</p>
                            </Alert>
                        )
                    })
                )}

                {(props.userError) ? (
                    <Alert type="error">
                        <p>{props.userError}</p>
                    </Alert>
                ) : null}

                {(props.match.params.token) ? null : (
                    <Alert type="error">
                        <p>You need a valid token</p>
                    </Alert>
                )}

                <Form onSubmit={props.handleSubmit}>

                    <StyledForgotMessage>
                        Please enter a new password below. Minimum 8 characters.
                    </StyledForgotMessage>

                    <StyledInput
                        error={props.touched.password && props.errors.hasOwnProperty('password')}
                        id="password"
                        label="Password"
                        onBlur={props.handleBlur}
                        onChange={props.handleChange}
                        placeholder="New password"
                        required={true}
                        tabIndex={1}
                        type="text"
                        onFocus={(event) => this.handleFocus(event)}
                    />

                    <LastStyledInput
                        error={props.touched.password && props.errors.hasOwnProperty('password')}
                        id="passwordConfirmation"
                        label="Confirm your password"
                        onBlur={props.handleBlur}
                        onChange={props.handleChange}
                        placeholder="Confirm password"
                        required={true}
                        tabIndex={2}
                        type="text"
                        onFocus={(event) => this.handleFocus(event)}
                    />

                    <SubmitButton
                        disabled={!props.isValid || props.isSubmitting}
                        type="submit"
                    >
                      Change password
                    </SubmitButton>
                </Form>
            </StyledForgotForm>
        )
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/RecoverForm/RecoverForm.tsx